import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard, EducationalBlock } from './shared';

const TimestampConverter = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [timestamp, setTimestamp] = useState('');
  const [format, setFormat] = useState('unix');
  const [res, setRes] = useState<any>(null);

  const handleConvert = () => {
    try {
      let date;
      if (format === 'unix') {
        date = new Date(parseInt(timestamp) * 1000);
      } else {
        date = new Date(timestamp);
      }
      const unix = Math.floor(date.getTime() / 1000);
      const iso = date.toISOString();
      const readable = date.toLocaleString('pt-BR');
      setRes({ unix, iso, readable });
      onResultChange([{ label: 'Unix', value: unix.toString() }, { label: 'ISO', value: iso }, { label: 'Legível', value: readable }]);
    } catch (e) {
      setRes({ error: 'Inválido' });
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="Valor" value={timestamp} onChange={setTimestamp} required />
          <FormField label="Formato" value={format} onChange={setFormat} type="select" options={[{ value: 'unix', label: 'Unix (s)' }, { value: 'iso', label: 'ISO 8601' }, { value: 'readable', label: 'Legível' }]} />
        </div>
        <div className="flex justify-center mb-6">
          <button onClick={handleConvert} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold flex items-center gap-2"><Icon name="refresh" className="w-5 h-5" /> Converter</button>
        </div>
        {res && !res.error && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <ResultCard title="Unix" value={res.unix} color="blue" />
            <ResultCard title="ISO" value={res.iso} color="purple" />
            <ResultCard title="Data" value={res.readable} color="indigo" />
          </div>
        )}
      </div>
    </div>
  );
};

export default TimestampConverter;
